<template>
  <v-layout
    v-if="appScheduledOrderActive"
    row
    wrap
  >
    <v-flex xs12>
      <v-expansion-panel class="elevation-0">
        <v-expansion-panel-content
          color="transparent"
          class="transparent cart-schedule-order"
        >
          <div
            slot="header"
            class="subheading gfp-adv-common-cart-coupon-text--text font-weight-medium pl-1"
          >
            <div>
              <div class="left mr-3">
                <v-icon color="gfp-adv-common-cart-coupon-icon">
                  mdi-clock
                </v-icon>
              </div>

              {{ $t('Cart.ScheduledOrder.Title') }}
              <div
                class="body-2"
                style="margin-left: 36px;"
              >
                {{ scheduledOrderSubtitle }}
              </div>
            </div>
          </div>

          <v-sheet class="pt-0 pb-2 px-3 transparent">
            <v-radio-group
              v-model="scheduledOrder"
              :disabled="IsLoading"
              class="mt-0"
              hide-details
              mandatory
              @change="setModelValue('scheduledOrder')"
            >
              <v-radio
                :disabled="IsLoading"
                :style="scheduledOrder === OrderTimeEnum.NOW ? 'border: #37abf6 1px solid;' : 'border: #a6a6a6 1px solid;'"
                class="rounded pa-2 mx-0"
                value="now"
              >
                <template #label>
                  <div>
                    <div class="font-weight-bold">
                      {{ $t('Cart.ScheduledOrder.Default.Title') }}
                    </div>
                    <div class="caption grey--text">
                      {{ storeTime }}
                    </div>
                  </div>
                </template>
              </v-radio>

              <v-radio
                :disabled="IsLoading"
                :style="scheduledOrder === OrderTimeEnum.SCHEDULED ? 'border: #37abf6 1px solid;' : 'border: #a6a6a6 1px solid;'"
                class="rounded pa-2 mx-0"
                value="scheduled"
              >
                <template #label>
                  <div>
                    <div class="font-weight-bold">
                      {{ $t('Cart.ScheduledOrder.Custom.Title') }}
                    </div>
                    <div class="caption grey--text">
                      {{ isDelivery ? $t('Cart.ScheduledOrder.Custom.Delivery') : $t('Cart.ScheduledOrder.Custom.Collection') }}
                    </div>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>

            <v-slide-y-transition>
              <div
                v-show="scheduledOrder === OrderTimeEnum.SCHEDULED"
                class="mt-2"
              >
                <v-container
                  fluid
                  pa-0
                >
                  <v-layout
                    row
                    wrap
                  >
                    <v-flex xs6>
                      <v-select
                        v-model="scheduledOrderDate"
                        :dense="$vuetify.breakpoint.xsOnly"
                        :disabled="IsLoading"
                        :items="scheduledOrderDates"
                        :label="$tc('Common.Date.Day', 1)"
                        hide-details
                        item-text="Name"
                        item-value="Value"
                        outline
                        return-object
                        class="mr-1"
                        @change="setModelValue('scheduledOrderDate')"
                      />
                    </v-flex>

                    <v-flex
                      xs6
                      class="pa-0"
                    >
                      <v-select
                        v-model="scheduledOrderTime"
                        :dense="$vuetify.breakpoint.xsOnly"
                        :disabled="IsLoading"
                        :items="scheduledOrderTimes"
                        :label="$tc('Common.Date.Hour', 1)"
                        hide-details
                        item-text="Name"
                        item-value="Value"
                        outline
                        class="ml-1"
                        return-object
                        @change="setModelValue('scheduledOrderTime')"
                      />
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
            </v-slide-y-transition>
          </v-sheet>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>
  </v-layout>
</template>

<script>

import OrderTimeEnum from '../../api/Enums/OrderTimeEnum'
import CartCommon    from '../../mixins/orders/cartCommon'
import AppData       from '../../mixins/appdata'
import OrderTypeTime from '../../mixins/orders/orderTypeTime'

export default {
  name      : 'ScheduledOrder',
  components: {},
  directives: {},
  mixins    : [AppData, CartCommon, OrderTypeTime],
  props     : {},
  data () {
    return {
      scheduledOrder    : OrderTimeEnum.NOW,
      scheduledOrderDate: null,
      scheduledOrderTime: null
    }
  },
  computed: {
    OrderTimeEnum () {
      return OrderTimeEnum
    },

    scheduledOrderSubtitle () {
      return this.scheduledOrder === OrderTimeEnum.NOW
        ? `${ this.storeTime }`
        : `${ this.scheduledOrderDate ? this.scheduledOrderDate.Name : '' } ${ this.scheduledOrderTime ? this.scheduledOrderTime.Name : '' }`
    },

    storeTime () {
      return this.isDelivery ? this.deliveryTime : this.collectionTime
    },

    scheduledOrderDates () {
      const dates = []
      const config = {
        sameDay : `[${ this.$t('Common.Date.Today') }]`,
        nextDay : `[${ this.$t('Common.Date.Tomorrow') }]`,
        nextWeek: 'ddd, DD/MM',
        lastDay : 'DD/MM/YYYY',
        lastWeek: 'DD/MM/YYYY',
        sameElse: 'DD/MM/YYYY'
      }

      const daysAhead = this.appScheduledOrderConfigByOrderType?.DaysAhead ?? 5
      const minOrderMinutesAhead = this.appScheduledOrderConfigByOrderType?.MinimumOrderMinutesAhead ?? 30
      const timeNow = this.$dayjs().add(minOrderMinutesAhead, 'minute')

      for (let d = timeNow.isToday() ? 0 : 1; d < daysAhead; d++) {
        const date = this.$dayjs().add(d, 'day')
        const obj = {
          Name : date.calendar(this.$dayjs(), config),
          Value: this.$dayjs(date).format('YYYY-MM-DD')
        }
        dates.push(obj)
      }

      return dates
    },
    scheduledOrderTimes () {
      const times = []
      const startTime = this.appScheduledOrderConfigByOrderType?.StartTime ?? 10
      const endTime = this.appScheduledOrderConfigByOrderType?.EndTime ?? 23
      const minOrderMinutesAhead = this.appScheduledOrderConfigByOrderType?.MinimumOrderMinutesAhead ?? 30
      const isTodaySelected = this.scheduledOrderDate?.Value === this.scheduledOrderDates[0]?.Value
      const timeNow = this.$dayjs().add(minOrderMinutesAhead, 'minute')
      const hourNow = isTodaySelected && timeNow.isToday() ? parseInt(timeNow.hour()) : startTime
      const minNow = isTodaySelected && timeNow.isToday() ? parseInt(timeNow.minute()) : minOrderMinutesAhead

      for (let h = hourNow; h < endTime; h++) {
        for (let m = 0; m < 60; m = m + 15) {
          if ((h === hourNow && m >= minNow && h >= startTime && h <= endTime) || (h > hourNow && h >= startTime && h <= endTime)) {
            const hour = String(h).padStart(2, '0')
            const min = String(m).padStart(2, '0')
            const time = `${ hour }:${ min }`
            times.push({
              Name : time,
              Value: time
            })
          }
        }
      }

      return times
    }
  },
  watch: {
    scheduledOrder (newVal) {
      if (newVal === OrderTimeEnum.NOW) {
        this.scheduledOrderDate = null
        this.scheduledOrderTime = null
      } else {
        this.scheduledOrderDate = this.scheduledOrderDates[0] || null
        this.scheduledOrderTime = this.scheduledOrderTimes[0] || null
      }
    },

    scheduledOrderDate (newVal, oldVal) {
      this.$nextTick(() => {
        if (newVal) {
          if (newVal?.Value !== oldVal?.Value) {
            const scheduledOrderTimeIndex = this.scheduledOrderTimes.findIndex(item => item.Value === this.scheduledOrderTime?.Value)
            this.scheduledOrderTime = scheduledOrderTimeIndex > -1 ? this.scheduledOrderTimes[scheduledOrderTimeIndex] : this.scheduledOrderTimes[0] || null
          }
        } else {
          this.scheduledOrderTime = null
        }
      })
    },

    'dataStore.cart.ScheduledOrder': {
      handler (newVal, oldVal) {
        this.updateValueFromModel()
      },
      immediate: true,
      deep     : true
    }
  },
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  methods: {
    updateValueFromModel () {
      this.scheduledOrder = this.cartScheduledOrder?.Type || OrderTimeEnum.NOW

      if (this.scheduledOrder === OrderTimeEnum.NOW) {
        this.scheduledOrderDate = null
        this.scheduledOrderTime = null
      } else {
        this.$nextTick(() => {
          this.$nextTick(() => {
            const scheduledOrderDateIndex = this.scheduledOrderDates.findIndex(item => item.Value === this.cartScheduledOrder?.Date)
            this.scheduledOrderDate = scheduledOrderDateIndex > -1 ? this.scheduledOrderDates[scheduledOrderDateIndex] : null

            const scheduledOrderTimeIndex = this.scheduledOrderTimes.findIndex(item => item.Value === this.cartScheduledOrder?.Time)
            this.scheduledOrderTime = scheduledOrderTimeIndex > -1 ? this.scheduledOrderTimes[scheduledOrderTimeIndex] : null

            this.$nextTick(() => {
              if (!this.scheduledOrderDate || !this.scheduledOrderTime) {
                this.scheduledOrder = OrderTimeEnum.NOW
                this.setModelValue('updateValueFromModel')
              }
            })
          })
        })
      }
    },

    setModelValue (t) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          const retVal = {
            Type    : this.scheduledOrder,
            Date    : this.scheduledOrder === OrderTimeEnum.NOW ? null : this.scheduledOrderDate?.Value || null,
            Time    : this.scheduledOrder === OrderTimeEnum.NOW ? null : this.scheduledOrderTime?.Value || null,
            DateTime: this.scheduledOrder === OrderTimeEnum.NOW ? null : this.scheduledOrderDate?.Value && this.scheduledOrderTime?.Value ? `${ this.scheduledOrderDate.Value } ${ this.scheduledOrderTime.Value }:00` : null
          }

          this.$nextTick(() => {
            if ((retVal.Type === OrderTimeEnum.NOW && !retVal.Date && !retVal.Time && !retVal.DateTime) ||
              (retVal.Type === OrderTimeEnum.SCHEDULED && retVal.Date && retVal.Time && retVal.DateTime)
            ) {
              this.$emit('change', retVal)
              this.$bus.$emit('cart-update-scheduled', retVal)
            }
          })
        })
      })
    }
  }
}
</script>

<style scoped>
.rounded {
  border-radius : 4px;
}

/deep/ .v-input--radio-group > .v-input__control {
  width : 100%;
}

/deep/ .v-text-field--outline > .v-input__control > .v-input__slot {
  border-width : 1px !important;
}

/deep/ .v-expansion-panel--active > .v-expansion-panel-header {
  min-height : 48px;
}
</style>
